document.addEventListener('DOMContentLoaded', function () {
    const toggleButtons = document.querySelectorAll('.js-password-toggle');

    toggleButtons.forEach(button => {
        button.addEventListener('click', function () {
            const input = this.previousElementSibling;
            if (input && input.tagName === 'INPUT') {
                const type = input.getAttribute('type') === 'password' ? 'text' : 'password';
                input.setAttribute('type', type);

                const icon = this.querySelector('.material-symbols-outlined');
                if (icon) {
                    icon.textContent = type === 'password' ? 'visibility_off' : 'visibility';
                }
            }
        });
    });
});
